import api from '../../../utils/api';
import { buildQuery } from '../../../utils/buildQuery';

export interface PaymentRequeryResult {
  transactionStatus: string;
  transactionReference: string;
  [key: string]: any;
}

export interface RequeryPaymentPayload {
  paymentReference: string;
  paymentChannel: string;
}

export const requeryPayment = async ({
  paymentReference,
  paymentChannel,
}: RequeryPaymentPayload): Promise<PaymentRequeryResult> => {
  const url = buildQuery({ paymentChannel });
  return (await api.get(`/Payment/${paymentReference}/QueryPayment${url}`))?.data;
};

export interface PaymentChannel {
  name: string;
  imageUrl: string | null;
  integrationKey: string | null;
  merchantCode: string | null;
  returnUrl: string | null;
  isActive: boolean | null;
  paymentUrl: string | null;
  institutionShortName: string;
}

interface PaymentChannelResponse {
  statusCode: number;
  message?: string;
  data?: PaymentChannel[];
}

export const getPaymentChannels = async (): Promise<PaymentChannel[]> => {
  const url = buildQuery({ isActive: true });
  const response = await api.get(`/Payment/GetPaymentChannel${url}`);
  return (response?.data as PaymentChannelResponse)?.data ?? [];
};
